import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogIn, ShieldCheck } from 'lucide-react';

export const Login: React.FC = () => {
  const { user, profile, login, loading, isPlatformAdmin } = useAuth();

  if (loading) return null;
  if (user) {
    if (profile?.role === 'admin' || (user.email && isPlatformAdmin(user.email))) {
      return <Navigate to="/admin" />;
    }
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-[#0A0A0A] border border-white/10 rounded-3xl p-10 shadow-2xl"
      >
        <div className="flex flex-col items-center text-center mb-10">
          <div className="relative w-20 h-20 rounded-full p-1 bg-[#261006] border border-[#caa062]/80 shadow-[0_8px_24px_rgba(0,0,0,0.9),inset_0_1.5px_2px_rgba(255,255,255,0.25)] shadow-[0_8px_24px_rgba(0,0,0,0.85)] mb-4">
            <img 
              src="/brand_logo.png?v=4" 
              alt="The Brown Pelican Man" 
              referrerPolicy="no-referrer"
              className="w-full h-full rounded-full object-contain" 
            />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight mb-1">The Brown Pelican Man</h1>
          <p className="text-[#ffe0a3]/70 font-mono text-xs uppercase tracking-widest">Portal & Communication Hub</p>
        </div>

        <button
          onClick={login}
          className="w-full py-4 text-[#ffe0a3] border border-[#d8aa68]/50 font-bold rounded-2xl flex items-center justify-center gap-3 hover:border-[#ffe0a3] transition-all active:scale-[0.98] shadow-lg"
          style={{
            background: 'linear-gradient(180deg, #4d2714 0%, #381b0e 38%, #241108 72%, #140803 100%)'
          }}
        >
          <LogIn size={20} />
          Continue with Google
        </button>

        <p className="mt-8 text-center text-xs text-gray-600 uppercase tracking-widest">
          Secure enterprise access
        </p>
      </motion.div>
    </div>
  );
};
